<pr-form (onSubmit)="submit()" [title]="title" [formGroup]="form">
  <h3>Réduction</h3>

  <pr-input label="Type" [derrors]="derrors">
    <mat-select formControlName="type">
      <mat-option [value]="null"> </mat-option>
      @for (type of fiscalType; track type) {
        <mat-option [value]="type.type">
          {{ 'api.taxReductionList.' + type.type.toLowerCase() | translate }}
        </mat-option>
      }
    </mat-select>
  </pr-input>

  <pr-input [label]="'Label'" [derrors]="derrors"
    ><input formControlName="label" type="text"
  /></pr-input>

  <pr-input label="Montant" suffix="€" [derrors]="derrors">
    <input formControlName="reductionAmount" type="text" />
  </pr-input>
</pr-form>
